import React from "react";
import { VaporDatePicker } from "../../vapor";
import { useIntl } from "react-intl";
import moment from "moment";

const InputsCreateAccYear = ({startDate, setStartDate, endDate, setEndDate}) => {

  const startLabel = useIntl().formatMessage({id: "accountingYear.startLabel"});
  const endLabel = useIntl().formatMessage({id: "accountingYear.endLabel"});

  return (
    <>
      <div className="single-input-container">
        <span className="input-label">{startLabel}</span>
        <VaporDatePicker 
          value={startDate}
          onChange={(value) =>
            setStartDate(value)
          }
          className="date-selector"
          getPopupContainer={(trigger) => trigger.parentNode}
        />
      </div>
    
      <div className="single-input-container">
        <span className="input-label">{endLabel}</span>
        <VaporDatePicker 
          value={endDate}
          onChange={(value) =>
            setEndDate(value)
          }
          className="date-selector"
          getPopupContainer={(trigger) => trigger.parentNode}
          disabledDate={(current) => {
            if (!startDate) return null;            
            return current && (current < moment(startDate, "YYYY-MM-DD").add(1, "years").subtract(1, "days") ||
            current > moment(startDate, "YYYY-MM-DD").add(15, "months"))
            ;
          }} 
        />
      </div>
    </>
  );
};

export default InputsCreateAccYear;